import {
  FACILITY_TYPE,
  FACILITY_SUBTYPE,
  ALL_FACILITY_SUBTYPES,
} from "@healthdesk/shared-utils";

export { FACILITY_TYPE, FACILITY_SUBTYPE, ALL_FACILITY_SUBTYPES };

// --- Type helpers (key off `type` field only) ---

/** @param {object | null | undefined} locationDoc */
export function isEmergencyDepartment(locationDoc) {
  return locationDoc?.type === FACILITY_TYPE.EMERGENCY_DEPARTMENT;
}

/** @param {object | null | undefined} locationDoc */
export function isClinic(locationDoc) {
  return locationDoc?.type === FACILITY_TYPE.CLINIC;
}

// --- Subtype helpers (key off `facilitySubtypes` array) ---

/** @param {object | null | undefined} locationDoc @param {string} subtype */
export function hasSubtype(locationDoc, subtype) {
  const subtypes = locationDoc?.facilitySubtypes;
  return Array.isArray(subtypes) && subtypes.includes(subtype);
}

/** @param {object | null | undefined} locationDoc */
export function isUrgentCare(locationDoc) {
  return hasSubtype(locationDoc, FACILITY_SUBTYPE.URGENT_CARE);
}

// --- Display labels ---

/** Patient-facing label. Urgent Care takes precedence over generic Clinic. */
/** @param {object | null | undefined} locationDoc */
export function getFacilityTypeLabel(locationDoc) {
  if (isEmergencyDepartment(locationDoc)) return "Emergency Department";
  if (isUrgentCare(locationDoc)) return "Urgent Care";
  if (isClinic(locationDoc)) return "Clinic";
  return locationDoc?.type || "Healthcare Facility";
}

/** Short label for map filter UI (matches existing filter key conventions). */
/** @param {object | null | undefined} locationDoc */
export function getFacilityFilterKey(locationDoc) {
  if (isEmergencyDepartment(locationDoc)) return "emergency";
  if (isUrgentCare(locationDoc)) return "urgent_care";
  return "clinic";
}

// Forward-compat note:
// facilitySubtypes is the field that the future `caremap-manager` role
// will manage via a dedicated CareMap Manager surface (role defined in
// ROLES_AND_PERMISSIONS.md; product surface TBD).
// For now: set at enrollment (facility/f2 role) and overridable by
// isFacilityDataAdmin() roles.
